import React, {Component} from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';
import {Card, Button, Loader} from 'semantic-ui-react';
import {catalogTransactions, transactionStatus as status} from '../../../common/dictionaries/parameters';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import FileLoader from '../../../common/components/fileUpload';
import JpmlProgressBar from './jpmlProgressBar';
import ContentMessage from './contentMessage';
import Header from './header';
import './fileLoader.scss';
import Modal from './Modal';
import PriceProgressBar from './priceProgressBar';

let timer;
const initialState = {
  'open': false,
};

class PartsCatalog extends Component {
  constructor(props) {
    super(props);
    this.state = {'catalog': null};
    this.handleFileUpload = this.handleFileUpload.bind(this);
    this.handleFileClear = this.handleFileClear.bind(this);
    this.handleSaveClick = this.handleSaveClick.bind(this);
    this.renderRetryMessage = this.renderRetryMessage.bind(this);
    initialState;
  }

  componentDidMount() {
    const {listOrigin} = this.props;

    if (!hasAccessPermission(this.props.permissions, resources.PartsCatalog, scopes.Create)) {
      this.props.navigateTo(paths.AccessDenied);
    }

    this.props.getTransactionStatus(catalogTransactions[listOrigin].transaction);
    this.props.getChangePricesStatus();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.listOrigin !== this.props.listOrigin) {
      this.setState({'catalog': null});
    }
  }

  handleFileUpload(event) {
    const files = event.target.files;
    
    if (files.length) {
      this.setState({'catalog': files[0]});
    }
  }

  handleFileClear() {
    this.setState({'catalog': null});
  }

  handleSaveClick() {
    const timeToConsiderRequestTimeout = 300000;
    timer = setTimeout(this.renderRetryMessage, timeToConsiderRequestTimeout);
    const {catalog} = this.state;

    if (catalog) {
      const data = new FormData();

      data.append('catalog', catalog);
      this.sendFile(data);
    }
  }

  sendFile(data) {
    const {listOrigin} = this.props;

    if (listOrigin === 'japan') {
      this.props.loadJapanPartMaster(data);
      return;
    }

    this.props.loadAlternativePartMaster(data);
  }

  renderRetryMessage() {
    const {addMessageBoxError, clearLoadingStatus} = this.props;
    addMessageBoxError('Problema al subir el archivo, por favor vuelve a intentar');
    clearLoadingStatus();
  }

  renderLoader(message) {
    return (
      <Loader active inline='centered'>{message}</Loader>
    );
  }

  renderFileLoader() {
    const {catalog} = this.state;
    const {listOrigin, updatingPrice} = this.props;
    if (catalog) {
      return (
        <Button secondary
          className='file-remover'
          onClick={this.handleFileClear}
          icon='close'
          content={catalog.name}
        />
      );
    }

    return (
      <FileLoader
        text='Subir Archivo'
        supportedFiles={catalogTransactions[listOrigin].fileType}
        changeActions={this.handleFileUpload}
        disabled = {updatingPrice}
      />
    );
  }

  renderSaveButton() {
    const {catalog} = this.state;

    return (
      <Button
        primary
        onClick={this.handleSaveClick}
        disabled={!catalog}
      >
        Guardar
      </Button>
    );
  }

  renderChangePricesButton() {
    const {updatingPrice} = this.props;
    return (
      <Button
        primary
        onClick={(e) => this.setState({'open': true})}
        disabled={updatingPrice}
      >
        Cambiar Precios
      </Button>
    );
  }

  renderButtons() {
    const {loadingFile, loadingStatus, transactionStatus} = this.props;
    const {statusCode} = transactionStatus;

    if (loadingFile || loadingStatus) {
      return this.renderLoader('Procesando...');
    }

    clearTimeout(timer);

    if (!statusCode || statusCode === status.completed || statusCode === status.failed) {
      return (
        <React.Fragment>
          {this.renderFileLoader()}
          {this.renderSaveButton()}
          {this.renderChangePricesButton()}
        </React.Fragment>
      );
    }

    return null;
  }

  renderContent() {
    const {loadingStatus, transactionStatus} = this.props;

    if (loadingStatus) {
      return this.renderLoader('Consultado el estado de la carga más reciente...');
    }

    return (<ContentMessage transactionStatus={transactionStatus} />);
  }

  renderProgressBar() {
    const {loadingStatus, transactionStatus} = this.props;
    const {statusCode} = transactionStatus;
    
    if (loadingStatus) {
      return this.renderLoader('Consultado el estado de la carga más reciente...');
    }

    if (_.isEmpty(transactionStatus) || statusCode === status.completed || statusCode === status.failed) {
      return null;
    }

    return (<JpmlProgressBar
      transactionStatus={transactionStatus}
      getTransactionStatus={this.props.getTransactionStatus}/>
    );
  }

  renderProgressBarPricess() {
    const {updatingPrice} = this.props;
    if (updatingPrice === false) {
      return null;
    }
    return (<PriceProgressBar/>);
  }
      
      handleModal = () => {
        this.setState({
          'open': false,
        });
      };
      // eslint-disable-next-line max-statements
      handleSubmit = (event, notification) => {
        this.setState({'open': false});
        this.props.changePartsPrice();
      }
      render() {
        const {open} = this.state;
        return (
          <div className='japan-part-master-load'>
            <Header />
            {open && (
              <Modal
                open={open}
                handleModal={this.handleModal}
                handleNotification={(e) => this.handleSubmit(e, 'S')}
              />
            )}
            <Card raised fluid className='body'>
              <div className='actions'>
                {this.renderButtons()}
              </div>
              {this.renderContent()}
              {this.renderProgressBar()}
              {this.renderProgressBarPricess()}
            </Card>
          </div>
        );
      }
}

const mapStateToProps = (state) => {
  return {
    'loadingFile': state.partsCatalog.loadingFile,
    'loadingStatus': state.partsCatalog.loadingStatus,
    'transactionStatus': state.partsCatalog.transactionStatus,
    'listOrigin': state.partsCatalog.listOrigin,
    'permissions': state.session.permissions,
    'updatingPrice': state.partsCatalog.updatingPrice,
    'updateRecords': state.partsCatalog.updateRecords,
  };
};

const {
  getTransactionStatus,
  loadJapanPartMaster,
  loadAlternativePartMaster,
  addMessageBoxError,
  clearLoadingStatus,
  navigateTo,
  changePartsPrice,
  getChangePricesStatus,
} = Actions;

export default connect(mapStateToProps, {
  getTransactionStatus,
  loadJapanPartMaster,
  loadAlternativePartMaster,
  addMessageBoxError,
  clearLoadingStatus,
  navigateTo,
  changePartsPrice,
  getChangePricesStatus,
})(PartsCatalog);
